import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    icon: {
        width: 60,
        height: 60
    }
}));
